import React, { useState, useEffect, useContext } from "react";
import { useLocation, useOutletContext } from "react-router-dom";
import { getQueryParams } from "lib/utils";
import { useTranslation } from "react-i18next";
import FormContainer from "components/form-container";
import { Input } from "components/input";
import AuthContext from "contexts/AuthContext";

export default function DropoffSellerConfirmDetails() {
  const location = useLocation();
  const queryParams = getQueryParams(location.search);
  const { t } = useTranslation();
  const { setSidebarVisual } = useOutletContext();
  const { user } = useContext(AuthContext);

  // Form state
  const [formData, setFormData] = useState({
    firstName: queryParams.firstName || user?.first_name || "",
    lastName: queryParams.lastName || user?.last_name || "",
    email: queryParams.email || user?.email || "",
    address:
      queryParams.address ||
      (user?.street && user?.city
        ? `${user.street}, ${user.city}${user.state ? `, ${user.state}` : ""}${user.zip ? ` ${user.zip}` : ""}`
        : "") ||
      "",
  });

  // Set sidebar visual
  useEffect(() => {
    setSidebarVisual("dollar");
  }, [setSidebarVisual]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isFormValid =
    formData.firstName &&
    formData.lastName &&
    formData.email &&
    formData.address;

  // Pass form data in query params
  const updatedParams = {
    ...queryParams,
    ...formData,
  };

  return (
    <FormContainer
      submitLabel={t("ui.button_continue")}
      submitHref="/en-US/dropoff-seller/terms-conditions"
      submitParams={updatedParams}
      submitDisabled={!isFormValid}
    >
      <div className="flex flex-col gap-regular">
        <h2 className="text-primary text-4xl md:text-6xl font-semibold">
          Hey, {formData.firstName || "there"}
        </h2>
        <p className="text-tertiary text-xl md:text-2xl">
          Please confirm your details.
        </p>
      </div>

      {/* Form */}
      <div className="w-full flex flex-col gap-large">
        <Input
          label="First name"
          type="text"
          name="firstName"
          value={formData.firstName}
          onChange={handleInputChange}
        />

        <Input
          label="Last name"
          type="text"
          name="lastName"
          value={formData.lastName}
          onChange={handleInputChange}
        />

        <Input
          label="Email address"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          disabled={true}
        />

        <Input
          label="Address"
          type="text"
          name="address"
          value={formData.address}
          onChange={handleInputChange}
        />
      </div>
    </FormContainer>
  );
}
